export default "__VITE_ASSET__C57b1axJ__"